module.exports = __webpack_public_path__ + "static/media/3.5Hp USHA PUMP.88ca52bd.jpg";